import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksSalesInvoiceForm.SalesInvoiceShippingSection', {
    sectionTitle: 'Shipping details',
    shippingToField: 'Shipping to',
    shippingToPlaceholder: 'Enter shipping to',
    shipViaField: 'Ship via',
    shipViaPlaceholder: 'Enter a text',
    shippingDateField: 'Shipping date',
    shippingDatePlaceholder: 'Enter shipping date',
    trackingNumberField: 'Tracking number',
    trackingNumberPlaceholder: 'Enter tracking number',
    shippingFromField: 'Shipping from',
    shippingFromPlaceholder: 'Enter shipping from',
    shippingPriceField: 'Shipping price ({currency})',
    shippingPricePlaceholder: 'Enter shipping price',
    shippingTaxCodeField: 'Shipping tax rate',
    shippingTaxCodePlaceholder: 'Select shipping tax rate',
});
